import { Checkbox } from "@/components/ui/checkbox";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { CategoryFormSchema } from "../forms/Forms";

interface Props {
  form: UseFormReturn<z.infer<typeof CategoryFormSchema>>;
  loading: boolean;
}

export const CategoryManualForm = ({ form, loading }: Props) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(() => {})} className="space-y-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Category Name</FormLabel>
              <FormControl>
                <Input placeholder="Name" disabled={loading} {...field} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="gl"
          render={({ field }) => (
            <FormItem>
              <FormLabel>GL Account Name</FormLabel>
              <FormControl>
                <Input
                  placeholder="GL Account Name"
                  disabled={loading}
                  {...field}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="isVisible"
          defaultValue={true}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Disabled</FormLabel>
              <FormControl>
                <div className="flex items-center">
                  <Checkbox
                    checked={!field.value}
                    onCheckedChange={(v) => field.onChange(!v)}
                    className="mr-2"
                  />
                  Disabled
                </div>
              </FormControl>
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};
